import { create } from "zustand";
import axios from "axios";
import { toast } from "react-toastify";

// Define the Zustand store
const useJobStore = create((set) => ({
  jobData: [],
  loadingAPI: false,
  error: null,

  // Function to fetch job data
  fetchJobs: async () => {
    set({ loadingAPI: true, error: null });
    try {
      const response = await axios.get("/user/jobs");
      set({ jobData: response.data.data, loadingAPI: false });
    } catch (error) {
      toast.error(error.message);
      set({ error: error.message, loadingAPI: false });
    }
  },
}));

export default useJobStore;
